module.exports = __webpack_public_path__ + "static/media/coollogo_com-113011439.93e02af7.png";